/**
 * @generated SignedSource<<6393c2d6102930798f03a421457d52f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCustomerHasActiveOrUpcomingMembership_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly id?: string;
      readonly memberPackages?: {
        readonly count: number;
      } | null | undefined;
      readonly upcomingMemberPackages?: {
        readonly count: number;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useCustomerHasActiveOrUpcomingMembership_session";
};
export type useCustomerHasActiveOrUpcomingMembership_session$key = {
  readonly " $data"?: useCustomerHasActiveOrUpcomingMembership_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCustomerHasActiveOrUpcomingMembership_session">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "type",
  "value": "MEMBERSHIP"
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCustomerHasActiveOrUpcomingMembership_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "status",
                      "value": "ACTIVE"
                    },
                    (v0/*: any*/)
                  ],
                  "concreteType": "MemberPackageConnection",
                  "kind": "LinkedField",
                  "name": "memberPackages",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": "memberPackages(status:\"ACTIVE\",type:\"MEMBERSHIP\")"
                },
                {
                  "alias": "upcomingMemberPackages",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "status",
                      "value": "UPCOMING"
                    },
                    (v0/*: any*/)
                  ],
                  "concreteType": "MemberPackageConnection",
                  "kind": "LinkedField",
                  "name": "memberPackages",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": "memberPackages(status:\"UPCOMING\",type:\"MEMBERSHIP\")"
                }
              ],
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "353932276a1c57578e2b574ebcee4c59";

export default node;
